import request from '@/utils/request'

// v80a1030List
export function v80a1030List(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/v80a1030/v80a1030List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//v80a1030Xls
export function v80a1030Xls(param) {
  let data = param
  return request({
      url: `/outsoucingBlockControl/v80a1030/v80a1030Xls`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
  }).then(res => {
      // console.log('v80a1030Xls RES', res)

      const binaryString = window.atob(res.body)
      const binaryLen = binaryString.length
      let bytes = new Uint8Array(binaryLen)

      for (let i = 0; i < binaryLen; i++) {
          let ascii = binaryString.charCodeAt(i)
          bytes[i] = ascii
      }

      const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
      const blobURL = URL.createObjectURL(blob)

      const link = document.createElement('a');
      link.href = blobURL;
      link.download = `Block Search.xls`;

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
  })
}